import { FETCH_PASSKEYS_SUCCEEDED, FETCH_PASSKEYS_FAILED } from "./types";

const initialState = {
    initialLoadingState: "loading",
    passkeys: [],
    error: {},
};

const passkeysReducer = (state = initialState, action) => {
    switch (action?.type) {
        case FETCH_PASSKEYS_SUCCEEDED:
            return {
                ...state,
                initialLoadingState: "loaded",
                passkeys: [...action.payload.data],
            };

        case FETCH_PASSKEYS_FAILED:
            return {
                ...state,
                initialLoadingState: "failed",
                error: action.payload,
            };

        default:
            return state;
    }
};

export default passkeysReducer;
